import { render } from "./CrmMenu.vue?vue&type=template&id=68393091&scoped=true"
import script from "./CrmMenu.vue?vue&type=script&lang=js"
export * from "./CrmMenu.vue?vue&type=script&lang=js"

import "./CrmMenu.vue?vue&type=style&index=0&id=68393091&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68393091"]])

export default __exports__